import { render, staticRenderFns } from "./GeonamesSearch.vue?vue&type=template&id=3c70d7c7&scoped=true&"
import script from "./GeonamesSearch.vue?vue&type=script&lang=js&"
export * from "./GeonamesSearch.vue?vue&type=script&lang=js&"
import style0 from "./GeonamesSearch.vue?vue&type=style&index=0&id=3c70d7c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70d7c7",
  null
  
)

export default component.exports